import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'kp-map-modal',
    templateUrl: './kp-map-modal.component.html',
    styleUrls: ['./kp-map-modal.component.scss'],
})
export class KpMapModalComponent implements OnInit {
    @Input() dismissOnBackdropClick = false;

    @Output() close: EventEmitter<void> = new EventEmitter();

    ngOnInit(): void {
        // no implementation
    }

    requestClose(): void {
        if (this.dismissOnBackdropClick) {
            this.close.emit();
        }
    }
}
